// extracted by mini-css-extract-plugin
export default {"nkColumnImgContainer":"NkColumnImage_nkColumnImgContainer__BBKc2","nkColumnImg":"NkColumnImage_nkColumnImg__My4CX","shadow":"NkColumnImage_shadow__xSSvS"};